/* Hang Dry: every signup is SMS first. A form marked data-hd-sms asks for a mobile number, subscribes it to
   SMS in Klaviyo, then turns the same field into an email field, subscribes that too, and closes out.
   Form attributes: data-source (Klaviyo custom source), data-success (closing line), data-email-placeholder,
   data-email-button (button text for the email step), data-hd-sms-hide (on the form or a row: hidden when done). Consent and messages sit just after the form. */
(function () {
  if (window.__hdSms) return;
  window.__hdSms = true;
  var CO = 'TqvUQM', LIST = 'Rkbg9B';
  var CONSENT = 'View our <a href="/policies/terms-of-service">Terms</a> and <a href="/policies/privacy-policy">Privacy</a>.';
  var design = !!(window.Shopify && window.Shopify.designMode);

  function digits(v) { return (v || '').replace(/\D/g, ''); }
  function e164(v) { var d = digits(v); if (d.length === 10) d = '1' + d; return '+' + d; }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim()); }

  function post(attrs, source) {
    if (design) return Promise.resolve(true);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function parts(form) {
    var input = form.querySelector('[data-hd-sms-input]') || form.querySelector('input[type="tel"], input[type="email"]');
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    var extra = form.nextElementSibling && form.nextElementSibling.classList.contains('hd-sms__after') ? form.nextElementSibling : null;
    if (!extra) {
      extra = document.createElement('div');
      extra.className = 'hd-sms__after';
      extra.innerHTML = '<p class="hd-sms__msg" role="status" hidden></p><p class="hd-sms__consent">' + CONSENT + '</p>';
      form.parentNode.insertBefore(extra, form.nextSibling);
    }
    return { input: input, btn: btn, msg: extra.querySelector('.hd-sms__msg'), consent: extra.querySelector('.hd-sms__consent') };
  }

  function say(p, text, bad) {
    p.msg.textContent = text;
    p.msg.hidden = !text;
    p.msg.classList.toggle('hd-sms__msg--err', !!bad);
  }

  // Prepare every form on the page (and any the cart drawer renders later): phone field, consent line
  function prep(root) {
    (root || document).querySelectorAll('form[data-hd-sms]:not([data-hd-sms-ready])').forEach(function (form) {
      form.setAttribute('data-hd-sms-ready', '');
      form.setAttribute('novalidate', '');
      var p = parts(form);
      if (!p.input) return;
      p.input.type = 'tel';
      p.input.setAttribute('inputmode', 'tel');
      p.input.setAttribute('autocomplete', 'tel');
      p.input.removeAttribute('name');
      if (!p.input.getAttribute('placeholder') || /mail/i.test(p.input.getAttribute('placeholder'))) p.input.setAttribute('placeholder', 'Mobile number');
      p.input.setAttribute('aria-label', 'Mobile number');
      form.querySelectorAll('label[for="' + p.input.id + '"]').forEach(function (l) { l.textContent = 'Mobile number'; });
      if (p.btn) form.dataset.smsButton = p.btn.innerHTML;
    });
  }

  document.addEventListener('input', function (e) {
    var form = e.target.form;
    if (!form || !form.hasAttribute('data-hd-sms') || form.dataset.step === 'email' || e.target.type !== 'tel') return;
    var d = digits(e.target.value).substring(0, 11), f = d;
    if (d.length > 10) f = d.substring(0, 1) + '-' + d.substring(1, 4) + '-' + d.substring(4, 7) + '-' + d.substring(7);
    else if (d.length > 6) f = d.substring(0, 3) + '-' + d.substring(3, 6) + '-' + d.substring(6);
    else if (d.length > 3) f = d.substring(0, 3) + '-' + d.substring(3);
    e.target.value = f;
  });

  // Capture on window: runs before, and stops, any older email handler bound to these forms
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-hd-sms')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    prep(form.parentNode);
    var p = parts(form), source = form.dataset.source || 'Site signup';
    if (!p.input || form.dataset.busy) return;
    var val = p.input.value.trim();
    var emailStep = form.dataset.step === 'email';
    if (!emailStep && digits(val).length < 10) { say(p, 'Enter a valid mobile number.', true); p.input.focus(); return; }
    if (emailStep && !validEmail(val)) { say(p, 'Enter a valid email address.', true); p.input.focus(); return; }
    form.dataset.busy = '1';
    if (p.btn) p.btn.disabled = true;
    var attrs = emailStep
      ? { email: val, phone_number: form.dataset.phone, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
      : { phone_number: e164(val), subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
    post(attrs, source).then(function (ok) {
      delete form.dataset.busy;
      if (p.btn) p.btn.disabled = false;
      if (!ok) { say(p, 'Something went wrong. Try again.', true); return; }
      if (!emailStep) {
        // Texts on: the same field now takes an email
        form.dataset.step = 'email';
        form.dataset.phone = e164(val);
        p.input.value = '';
        p.input.type = 'email';
        p.input.setAttribute('inputmode', 'email');
        p.input.setAttribute('autocomplete', 'email');
        p.input.setAttribute('placeholder', form.dataset.emailPlaceholder || 'Email address');
        p.input.setAttribute('aria-label', 'Email address');
        form.querySelectorAll('label[for="' + p.input.id + '"]').forEach(function (l) { l.textContent = 'Email'; });
        if (p.btn && form.dataset.emailButton) p.btn.innerHTML = form.dataset.emailButton;
        if (p.consent) p.consent.hidden = true;
        say(p, 'Texts are on. Add your email for the rest.');
        p.input.focus();
        return;
      }
      form.dataset.step = 'done';
      // Done: hide what data-hd-sms-hide marks (the whole form, or its input row), else just the field and button
      var hide = form.hasAttribute('data-hd-sms-hide') ? form : form.querySelector('[data-hd-sms-hide]');
      if (hide) hide.hidden = true;
      else [p.input, p.btn].concat([].slice.call(form.querySelectorAll('label[for="' + p.input.id + '"]'))).forEach(function (el) { if (el) el.hidden = true; });
      say(p, form.dataset.success || "You're in.");
      try { localStorage.setItem('hd_ship_subscribed', '1'); } catch (x) {}
      var bar = form.closest('.hd-ship');
      if (bar) bar.classList.add('hd-ship--subscribed');
    });
  }, true);

  function init() { prep(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 50); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', init);

  var css = document.createElement('style');
  css.textContent = '.hd-sms__msg{margin:8px 0 0;font-size:13px;line-height:1.4}.hd-sms__msg--err{color:#B42318}' +
    '.hd-sms__consent{margin:8px 0 0;font-size:11px;line-height:1.45;opacity:.72;text-transform:none;letter-spacing:0}' +
    '.hd-sms__consent a{color:inherit;text-decoration:underline}';
  document.head.appendChild(css);
})();